import {IGenotypeGroup} from 'Genotype/models/IGenotypeGroup';
import {GenotypeType} from 'Genotype/constants/GenotypeType';
import {IGenotype} from 'Genotype/models/IGenotype';

export function getGenotypesByType(genotypeGroups: IGenotypeGroup[], type: GenotypeType): IGenotype[] {
  return genotypeGroups.find(group => group.name === type)?.genotypes || [];
}
